import React from "react";
import { FormattedMessage } from "react-intl";

const InstallmentSummary = ({ index, installment }) => {
  return (
    <div className="dbx-inst-summary-container">
      <h4 className="dbx-inst-summary-title"> Rata {index + 1}</h4>
      <div className="dbx-inst-summary-info-container">
        <p className="dbx-inst-summary-info-title">
          <FormattedMessage id="parties.paymentMode" />{" "}
        </p>
        :
        <span className="dbx-inst-summary-info-description">
          <FormattedMessage
            id={`parties.payment.${installment?.paymentMethods?.[0]}`}
          />{" "}
        </span>
        <p className="dbx-inst-summary-info-title">
          <FormattedMessage id="parties.paymentTime" />{" "}
        </p>
        :
        <span className="dbx-inst-summary-info-description">
          {installment?.dueDate?.days}gg{" "}
          {installment?.dueDate?.from === "DOCUMENT_DATE_END_OF_MONTH"
            ? "data fine mese"
            : "data fattura"}
        </span>
        <p className="dbx-inst-summary-info-title">
          <FormattedMessage id="parties.paymentTitle" />{" "}
        </p>
        :
        <span className="dbx-inst-summary-info-description">
          {" "}
          {installment?.fractionOver10K / 100}%
        </span>
      </div>
    </div>
  );
};

export default InstallmentSummary;
